import React from 'react';
import PropTypes from 'prop-types';
import OrderOnCallButton from '../Button/OrderOnCallButton';
import * as Constants from '../../constants';
require('./RefillCard.scss');

const onClickRefill = (redirectUrl) => {
  window.open(redirectUrl);
}

const RefillCard = ({ refillDetails, currentIndex, index, actions }) => {
  return (
    <div className={"RefillContainer" + (index == currentIndex ? ' ActiveItem' : '')}>
      <div className="RefillHeader">
        <div className="RefillDetailComponent">
          <div className="RefillDetailTitle">{refillDetails.detail.name}</div>
          <div className="RefillDetailText">Refill No. {refillDetails.detail.id}</div>
        </div>
        <div className="RefillDetailComponent">
          <div className="RefillDetailTitle">Status - {refillDetails.detail.status && refillDetails.detail.status.message}</div>
          <div className="RefillDetailText">Placed on: {refillDetails.detail.createdDate}</div>
        </div>
        <div className="RefillDetailComponent">
          <div className="RefillDetailTitle">Next Delivery Date</div>
          <div className="RefillDetailText">{refillDetails.detail.nextDeliveryDateText}</div>
        </div>
        <div className="RefillDetailComponent">
          <OrderOnCallButton
            type={1} text="View Refill Details"
            onClickFunction={() => onClickRefill(`${Constants.CMS_URL_SUBSCRIPTION}?id=${refillDetails.detail.id}`)}
          />
        </div>
      </div>
      <div className="RefillMedicineContainer">
        {(refillDetails.medicinesToShow && refillDetails.medicinesToShow.length > 0) ?
          <div className="RefillMedicineHeader">Medicines</div> :
          <div className="RefillMedicineHeader">No Medicines</div>}
        <div className="RefillMedicineDetails">
          {refillDetails.medicinesToShow && refillDetails.medicinesToShow.length > 0 &&  refillDetails.medicinesToShow.map((item) =><div>{item.name}</div>)}
        </div>
      </div>
    </div>
  );
}

RefillCard.propTypes = {
  refillDetails: PropTypes.object.isRequired,
};

export default RefillCard;
